import React, { createContext, PropsWithChildren } from "react";
import { SiteSettings } from "../models/shared/SiteSettings";

const SiteSettingsContext = createContext<SiteSettings>({} as SiteSettings);

interface SiteSettingsProviderProps {
  siteSettings: SiteSettings;
}

const SiteSettingsContextProvider = ({
  siteSettings,
  children
}: PropsWithChildren<SiteSettingsProviderProps>) => (
  <SiteSettingsContext.Provider value={siteSettings || {}}>
    {children}
  </SiteSettingsContext.Provider>
);

export { SiteSettingsContext, SiteSettingsContextProvider };
